const scrollBack = (scrollX: number) => {
    let x = scrollX + Math.round(window.innerWidth / 2)
    if (x > 10) x = 10
    return x
}

const scroolFoward = (scrollX: number, cards: CardsConecta[]) => {
    let x = scrollX - Math.round(window.innerWidth / 2);
    let listw = cards.length * 240;

    if ((window.innerWidth - listw) > x) {
        x = (window.innerWidth - listw) - 50
    }
    return x
}


const searchCard = (cards: CardsConecta[], values: string | undefined) => {
    if (values) {
        const lowerValues = values.toLowerCase()
        const card = cards.filter((card: CardsConecta) => card.title.toLowerCase().includes(lowerValues))
        return card
    }

    return "";
}

const searchCategoryBi = (categories: CategoryBI[], values: string | undefined) => {
    if (values) {
        const lowerValues = values.toLowerCase()
        const categorie = categories.filter((cat: CategoryBI) => cat.name.toLowerCase().includes(lowerValues))
        return categorie
    }
    return "";
}

const slugify = (str: string) =>
        str
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, '')
            .replace(/[\s_-]+/g, '-')
            .replace(/^-+|-+$/g, '')


const resize = (setImageInput, file ) => {
    const MAX_WIDTH = 300
    const MAX_HEIGHT = 300
    
    let img = new Image()
    img.src = URL.createObjectURL(file)

    const createFileFromBlob = (blob) => {
        //criamos um file com o blob passando o nome da imagem, o tipo e a ultima modificação
        const imageResized = new File([blob], file.name, {
          type: file.type,
          lastModified: Date.now()
        });
        //callback function que será a sua função de upload para os servidor
        console.log(imageResized)
        const reader =  new FileReader()

        reader.addEventListener(
            "load",
            () => {
                let base = reader.result
                console.log(base)
                setImageInput(base as string)
            },
            false
            
        )
        if(file) {
            reader.readAsDataURL(imageResized)
        }
        
      };

    img.onload = () => {
        let canvas = document.createElement("canvas")
        let ctx = canvas.getContext("2d")
        
        let width = img.width;
        let height = img.height;

        if (width > height) {
            if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
            }
        } else {
            if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
            }
        }

        canvas.width = width;
        canvas.height = height;

        ctx?.drawImage(img, 0, 0, width, height);

        ctx?.canvas.toBlob(createFileFromBlob, file.type, 0.8);
    }

}

export { scrollBack, scroolFoward, searchCard, searchCategoryBi, slugify, resize }